import React from 'react';
import type {
  User,
  Namespace,
} from '@gymcloud/core';

import {
  Flex,
  TextBold,
} from 'web-styled';

import Pro from './Pro';
import Client from './Client';
import OnboardingVideo from './OnboardingVideo';
import Trainer from './Trainer';
import Activity from './Activity';
import * as S from './styled';

type Props = {
  profile: User,
  namespace: Namespace;
};

const Dashboard = ({
  profile,
  namespace,
}: Props) => {
  const isPro = profile.is_pro;
  const steps = profile.user_settings.tutorial_steps;

  const trainerVisible = !isPro && namespace.symbol === 'gymcloud';
  const onboardingVisible = isPro && steps.indexOf('video_tutorial') === -1;

  return (
    <Flex fillSpace column>
      <S.Header>
        <TextBold color="#fff" size="30px">
          Dashboard
        </TextBold>
        {trainerVisible && <Trainer />}
      </S.Header>
      <Flex fillSpace scrollY>
        {isPro ? <Pro /> : <Client />}
        {(onboardingVisible || namespace.symbol !== 'ideafit') && (
          <Flex flex="0 0 236px">
            <S.RightSide>
              {onboardingVisible && <OnboardingVideo />}
              {namespace.symbol !== 'ideafit' && (
                <Activity />
              )}
            </S.RightSide>
          </Flex>
        )}
      </Flex>
    </Flex>
  );
};

export default Dashboard;
